import { combineReducers } from 'redux';

import kontaktMeg, { KontaktMegState } from './kontakt-meg';

export interface ApplicationState {
    kontaktMeg: KontaktMegState;
}

// @ts-expect-error just suppressing redux ts error
export default combineReducers<ApplicationState>({ kontaktMeg });
